module.exports = __webpack_public_path__ + "img/left7.f8d7f7e.svg";